import { createContext, useContext } from "react";

const CardContext = createContext({
  collapsed: false,
  setCollapsed: (collapsed: boolean) => {},
});

export const useCardContext = () => useContext(CardContext);

export default CardContext;
